module.exports = __webpack_public_path__ + "img/microneedling-user-guide.3e4e6503.svg";